module.exports = __webpack_public_path__ + "img/rejoignez_nous.234cc7b3.jpg";